import React, {Component} from "react"
import PropTypes from "prop-types"
import {Row, Col, Panel} from "react-bootstrap"

import {TextArea} from "@irati/ui/src/FormItem"
import Validation from "@irati/utils/validation"
import id from "@irati/utils/id"
import ImportantInfoList from "@irati-web/perks/src/components/ImportantInfoList"
import ErrorText from "@irati/ui/src/ErrorText"
import {
  getErrorIfContains,
  getBulletPointListItems,
  containsLinks,
  containsItalicStyling,
  containsImages,
  containsHeadings,
  containsHorizontalRules,
  containsLegacyBulletPoints,
  containsHtml,
  containsInvalidDoubleBulletPoints,
  regEx,
  getListItemsFromMarkdown
} from "@irati/utils/markdown"
import StyledMarkdownCol from "../deal/styled/MarkdownCol"
import withRewardOnChange from "./withRewardOnChange"
import {toString, toArray} from "./utils"


const getError = (value) => {
  if (!value) {
    return null
  }
  let error = null
  if (value.search(regEx.bulletPoint) !== 0) {
    error = "This field must start with a bullet point."
  } else if ((getBulletPointListItems(value) || []).length > 7) {
    error = "This field only allows 7 bullet points."
  } else if ((value.match(regEx.atLeastOneChar) || []).length > 0) {
    error = "Each bullet point must have at least one character."
  } else if ((value.match(regEx.sequentialBulletChar) || []).length > 0) {
    error = "Each bullet point must have at least one character."
  } else {
    getListItemsFromMarkdown(value).forEach((importantInfoItem) => {
      if (importantInfoItem.length > 80) {
        error = "This field only allows a maximum of 80 characters per bullet point."
      }
    })
    error = error ||
      getErrorIfContains(value, [
        containsLinks,
        containsItalicStyling,
        containsImages,
        containsHeadings,
        containsHorizontalRules,
        containsLegacyBulletPoints,
        containsHtml,
        containsInvalidDoubleBulletPoints
      ])
  }
  return error
}


export const schema = (required) =>
  Validation
    .string(required ? "This field is required" : null)
    .test(
      "importantInfo-md-valid",
      "error",
      (value) => {
        return Validation.customError(getError(value))
      }
    )

const PROPERTY = "importantInfo"

class ImportantInfo extends Component {
  static propTypes = {
    reward: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    required: PropTypes.bool,
    label: PropTypes.string,
    panelTitle: PropTypes.string
  }

  static defaultProps = {
    required: true,
    label: "Important info:",
    hint: "Available markdown: Bullet points, bold styling.",
    panelTitle: "How it will display",
    id: "importantInfo"
  }


  constructor(props) {
    super(props)
    this.state = {
      value: toString(props.reward, PROPERTY)
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const {reward} = nextProps
    const nextValue = toString(reward, PROPERTY)
    if (this.state.value !== nextValue) {
      this.setState({value: nextValue})
    }
  }

  handleChange = (value) => {
    this.setState({value})
  }

  handleBlur = () => {
    const {onChange, reward} = this.props
    onChange(reward, PROPERTY, toArray(this.state.value))
  }

  render() {
    const {reward, required, label, panelTitle, ...props} = this.props
    const {value} = this.state

    const error = getError(value)

    return (
      <Row>
        <Col xs={6}>
          <TextArea
            name={PROPERTY}
            value={value}
            validation={schema(required)}
            rows={8}
            label={`${label}${required ? "*" : ""}`}
            {...props}
            onChange={this.handleChange}
            onBlur={this.handleBlur}
            id={id(PROPERTY, props)} />
        </Col>
        <StyledMarkdownCol xs={6}>
          <Panel bsStyle="info" header={panelTitle}>
            {!error && <ImportantInfoList data={toArray(value)} />}
            {error && <ErrorText>{error}</ErrorText>}
          </Panel>
        </StyledMarkdownCol>
      </Row>
    )
  }
}

export default withRewardOnChange(ImportantInfo)
